import React, { useEffect, useCallback } from "react";
import useState from "react-usestateref";
import { Button } from "@material-ui/core";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";
import { socket } from "../context/socket";
import "./Trade.css";
import "./FutureTrade.css";
import "./OptionalTrade.css";
import { toast } from "react-toastify";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import apiService from "../core/service/detail";
import { getMethod, postMethod } from "../core/service/common.api";
import { createTheme, ThemeProvider } from "@mui/material";
import { Dropdown } from "semantic-ui-react";
import Modal from "@mui/material/Modal";
import axios from "axios";
import { calculateTradeMetrics } from './calculateTradeMetrics';
import { Bars } from "react-loader-spinner";
import TradingViewWidget from './futuretradeChart';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};

function FutureTrade() {
  const [activeTab, setActiveTab] = useState("mytrade");
  const [activeLimits, setActiveLimits, activeLimitsref] = useState("market");
  const [activeTabhead, setActiveTabHead, activeTabheadref] =
    useState("orders");
  const [isChecked, setIschecked] = useState(false);
  const [isCheckedReduce, setIscheckedReduce] = useState(false);
  const [options, setoptions] = useState([
    { key: "BTC", text: "BTC", value: "BTC" },
    { key: "USDT", text: "USDT", value: "USDT" },
  ]);

  const themeSlider = createTheme({
    components: {
      MuiSlider: {
        styleOverrides: {
          thumb: {
            width: 13,
            height: 13,
            borderRadius: 0,
            border: "2px solid #888B93",
            backgroundColor: "#1E2026",
            transform: "rotate(45deg)",
            transformOrigin: "center",
            marginLeft: -12,
            marginTop: -6,
          },
          track: {
            backgroundColor: "#1E2026",
          },
        },
      },
    },
  });

  const handleLimit = async (value) => {
    setActiveLimits(value);
    handleSliderChange("", 0);

    setInputs((prev) => ({
      ...prev,
      limitprice: markPrice,
      stoplimitprice: markPrice,
    }));
  };

  const handleTabs = async (value) => {
    setActiveTabHead(value);
  };

  const handleTerms = (event) => {
    setIschecked(event.target.checked);
  };

  const handleTermsReduce = (event) => {
    setIscheckedReduce(event.target.checked);
    setIschecked(false);
  };

  const [siteLoader, setSiteLoader, siteLoaderref] = useState(false);
  const [BookError, setBookError] = useState(null);
  const [orderBook, setOrderBook] = useState({ bids: [], asks: [] });
  const [CurrencyList, setCurrencyList] = useState([]);
  const [currentPair, setcurrentPair] = useState("");
  const [tickerPrice, setTickerPrice] = useState(null);

  const [Fromcurrency, setFromcurrency] = useState("BTC");
  const [Tocurrency, setTocurrency] = useState("USDT");
  const [markPrice, setmarkPrice] = useState(0);
  const [min, setmin] = useState(0);
  const [Max, setMax] = useState(0);



  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    setSiteLoader(true);
    var urls = window.location.href;
    var pair = urls.split("trade/")[1];
    var changelower = pair.toUpperCase();
    setcurrentPair(changelower);
    getLiveMarket(changelower);
    const From = changelower.split("USDT")[0];
    setFromcurrency(From);
    const Pair = `${From}_USDT`;
    getUserbalance(Pair);
    setoptions([
      { key: From, text: From, value: From },
      { key: "USDT", text: "USDT", value: "USDT" },
    ]);
    return () => {
      socket.off("OptionalMarket");
    };
  }, [currentPair]);

  const pairChange = async (pair) => {

    setcurrentPair(pair);
    navigate("/futuretrade/" + pair);

  };

  const getLiveMarket = async (underlying) => {
    try {
      setSiteLoader(true);
      setBookError(null);

      socket.emit("GetFutureTickerPrice", { symbol: underlying });
      socket.emit("GetFutureOrderBook", { symbol: underlying });
      socket.emit("GetAllFutureTickerPrice");
      socket.off("FutureOrderBook");
      socket.off("FutureTickerPrice");
      socket.off("FutureallOrderBook");
      socket.on("FutureTickerPrice", (response) => {
        if (response?.data) {
          setTickerPrice(response.data);
          setmarkPrice(response.data?.curDayClose);
        } else {
          setBookError("No data received");
        }
        setSiteLoader(false);
      });

      socket.on("FutureOrderBook", (response) => {
        if (response?.data) {
          const data = response.data;
          setOrderBook({
            bids: data.bidDepth?.slice(0, 10) || [],
            asks: data.askDepth?.slice(0, 10) || [],
          });
        } else {
          setBookError("No data received");
        }
        setSiteLoader(false);

      });

      socket.on("FutureallOrderBook", (response) => {

        if (response?.data) {
          const data = response.data;
          setCurrencyList(data);
        } else {
          setBookError("No data received");
        }

        setSiteLoader(false);
      });

      // Set min/max quantity from exchangeInfo (as you're already doing)
      const exchangeInfo = await axios.get('https://fapi.binance.com/fapi/v1/exchangeInfo');


      const symbolInfo = exchangeInfo.data.symbols.find(s => s.symbol === currentPair);

      const lotSizeFilter = symbolInfo.filters.find(f => f.filterType === "LOT_SIZE");
      const minNotionalFilter = symbolInfo.filters.find(f => f.filterType === "MIN_NOTIONAL");

      const maxQty = parseFloat(lotSizeFilter.maxQty);
      const minQty = parseFloat(lotSizeFilter.minQty);
      const minNotional = parseFloat(minNotionalFilter.notional);

      setmin(minQty);
      setMax(maxQty);


      setTimeout(() => {
        if (siteLoaderref.current) {
          setSiteLoader(false);
          setBookError("No Data Found");
        }
      }, 10000);
    } catch (err) {
      setSiteLoader(false);
      setBookError(err.message);
    }
  };


  const updateTradeMetrics = () => {


    let price = 0;
    let size = 0;

    if (activeLimitsref.current === "market") {
      price = markPrice;
      size = inputsref.current.size;
    } else if (activeLimitsref.current === "limit") {
      price = inputsref.current.limitprice;
      size = inputsref.current.limitsize;
    } else if (activeLimitsref.current === "stoplimit") {
      price = inputsref.current.stoplimitprice;
      size = inputsref.current.stopsize;
    }

    const { cost, max, liqPrice, sellliqPrice } = calculateTradeMetrics({
      price,
      size,
      leverage,
      balance: tobalanceref.current,
    });

    setTradeMetrics({
      buy: { cost, max, liqPrice },
      sell: { cost, max, liqPrice: sellliqPrice },
    });

  };


  const [tradeMetrics, setTradeMetrics] = useState({
    buy: { cost: 0, max: 0, liqPrice: 0 },
    sell: { cost: 0, max: 0, liqPrice: 0 },
  });




  const [frombalance, setFromBalance, frombalanceref] = useState(0);
  const [tobalance, settobalance, tobalanceref] = useState(0);

  const getUserbalance = async (pair) => {
    var obj = {
      pair: pair,
    };
    var data = {
      apiUrl: apiService.getparUserBalance,
      payload: obj,
    };
    setSiteLoader(true);
    var resp = await postMethod(data);
    setSiteLoader(false);

    if (resp.status) {
      var getFromBalance = resp.data?.fromCurrency;
      var getToBalance = resp.data?.toCurrency;
      setFromBalance(getFromBalance?.totalBalance);
      settobalance(getToBalance?.totalBalance);
    } else {
    }
  };

  const changeprice = parseFloat(tickerPrice?.priceChangePercent).toFixed(2);
  const isNegative = parseFloat(changeprice) < 0;

  const [marginMode, setMarginMode] = useState("Cross");
  const [amount, setAmount] = useState("");
  const [sliderValue, setSliderValue] = useState(0);
  const [inputs, setInputs, inputsref] = useState({
    limitprice: "",
    limitsize: "",
    stopprice: "",
    stoplimitprice: "",
    stopsize: "",
    size: "",
    takeProfit: "",
    stopLoss: "",
  });

  const [open, setOpen] = useState(false);
  const [leverOpen, setleverOpen] = useState(false);

  const [loginStatus, setLoginStatus] = useState(false);
  useEffect(() => {
    let token_check = sessionStorage.getItem("user_token");
    if (token_check) {
      setLoginStatus(true);
      History();

    } else {
      setLoginStatus(false);
    }
  }, []);


  const loginNave = async () => {
    navigate("/login");
  };
  const handleleverOpen = () => setleverOpen(true);
  const handleOpen = () => setOpen(true);

  const [leverage, setLeverage] = useState(10);

  const handleClose = () => {
    setOpen(false);
    setleverOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
    updateTradeMetrics();

    if (name == "size" || name == "limitsize" || name == "stopsize") {
      setSliderValue(0);
    }

  };

  const handleSliderChange = (e, value) => {
    setSliderValue(value);

    const balance = parseFloat(tobalanceref.current) || 0;
    const lev = parseFloat(leverage) || 1;

    const size = ((balance * lev) * (value / 100)).toFixed(4);

    const sizeKey =
      activeLimitsref.current === "market"
        ? "size"
        : activeLimitsref.current === "limit"
          ? "limitsize"
          : "stopsize";

    setInputs((prev) => ({ ...prev, [sizeKey]: size }));
    updateTradeMetrics();

  };

  const renderInputs = () => {
    const type = activeLimitsref.current;

    if (type === "market") {
      return (
        <>
          <div className="future_rght_scndinp">
            <input
              type="number"
              name="size"
              min={0}
              value={inputsref.current.size}
              onChange={handleInputChange}
              className="future_rght_frstinp_inner"
              placeholder="Size"
            />
            <div className="futre_chng_frst">
              <Dropdown inline placeholder={Fromcurrency} options={options} />
            </div>
          </div>
        </>
      );
    }

    if (type === "limit") {
      return (
        <>
          <div>
            <div className="future_rght_frstinp_lef">
              <input
                type="number"
                name="limitprice"
                value={inputsref.current.limitprice}
                onChange={handleInputChange}
                min={0}
                className="future_rght_frstinp_inner"
                placeholder="Price"
              />
              <span className="futu_frsinnp_span">USDT</span>
            </div>
          </div>

          <div className="future_rght_scndinp">
            <input
              type="number"
              name="limitsize"
              min={0}
              value={inputsref.current.limitsize}
              onChange={handleInputChange}
              className="future_rght_frstinp_inner"
              placeholder="Size"
            />
            <div className="futre_chng_frst">
              <Dropdown inline placeholder={Fromcurrency} options={options} />
            </div>
          </div>
        </>
      );
    }

    if (type === "stoplimit") {
      return (
        <>
          <div className="">
            <div className="future_rght_frstinp_lef">
              <input
                type="number"
                name="stopprice"
                value={inputsref.current.stopprice}
                min={0}
                onChange={handleInputChange}
                className="future_rght_frstinp_inner"
                placeholder="Stop Price"
              />
              <span className="futu_frsinnp_span">
                {/* <span>{tradeSettings.priceLabel}</span> */}
              </span>
            </div>
          </div>

          <div className="">
            <div className="future_rght_frstinp_lef p-3">
              <input
                type="number"
                name="stoplimitprice"
                value={inputsref.current.stoplimitprice}
                min={0}
                onChange={handleInputChange}
                className="future_rght_frstinp_inner"
                placeholder="Price"
              />
            </div>
          </div>

          <div className="future_rght_scndinp">
            <input
              type="number"
              name="stopsize"
              value={inputsref.current.stopsize}
              onChange={handleInputChange}
              min={0}
              className="future_rght_frstinp_inner"
              placeholder="Size"
            />
            <div className="futre_chng_frst">
              <Dropdown inline placeholder={Fromcurrency} options={options} />
            </div>
          </div>
        </>
      );
    }
  };

  const validateOrder = () => {
    const type = activeLimitsref.current?.toLowerCase();
    if (type === "market") {
      if (!inputsref.current.size || Number(inputsref.current.size) <= 0) {
        return "Size is required and must be greater than 0 for market orders";
      }
    }

    // Validate Limit Order
    if (type === "limit") {
      if (!inputsref.current.limitprice || Number(inputsref.current.limitprice) <= 0) {
        return "Price is required and must be greater than 0 for limit orders";
      }
      if (!inputsref.current.limitsize || Number(inputsref.current.limitsize) <= 0) {
        return "Size is required and must be greater than 0 for limit orders";
      }
    }

    // Validate Stop Limit Order
    if (type === "stoplimit") {
      if (!inputsref.current.stopprice || Number(inputsref.current.stopprice) <= 0) {
        return "Stop price is required and must be greater than 0 for stop-limit orders";
      }
      if (!inputsref.current.stoplimitprice || Number(inputsref.current.stoplimitprice) <= 0) {
        return "Limit price is required and must be greater than 0 for stop-limit orders";
      }
      if (!inputsref.current.stopsize || Number(inputsref.current.stopsize) <= 0) {
        return "Size is required and must be greater than 0 for stop-limit orders";
      }
    }

    // TP/SL Validation
    if (isChecked) {
      if (!inputsref.current.takeProfit || Number(inputsref.current.takeProfit) <= 0) {
        return "Take Profit value is required and must be greater than 0";
      }
      if (!inputsref.current.stopLoss || Number(inputsref.current.stopLoss) <= 0) {
        return "Stop Loss value is required and must be greater than 0";
      }
    }

    return null; // All validations passed
  };


  const History = async () => {
    setSiteLoader(true);
    getOpenOrders();
    getOrderHistory();
    getTradeHistory();
    setSiteLoader(false);
  };


  const [openOrrders, setOpenOrders, openOrrdersref] = useState([]);
  const [tradeHistory, setTradeHistory, tradeHistoryref] = useState([]);
  const [orderhistory, setOrderHistory, orderhistoryref] = useState([]);

  const getOpenOrders = async () => {
    try {
      const data = {
        apiUrl: apiService.futureOpenOrders,
      };
      setSiteLoader(true);
      const resp = await getMethod(data);
      setSiteLoader(false);

      if (resp.status == "true") {
        setOpenOrders(resp.data);
      } else {
        setOpenOrders([]);
      }
    } catch (error) {
      setOpenOrders([]);
    }
  };

  const getOrderHistory = async () => {
    try {
      const data = {
        apiUrl: apiService.futureOrderHistory,
      };
      setSiteLoader(true);
      const resp = await getMethod(data);
      setSiteLoader(false);

      if (resp.status) {
        setOrderHistory(resp.data);
      } else {
        setOrderHistory([]);

      }
    } catch (error) {
      setOrderHistory([]);

    }
  };

  const getTradeHistory = async () => {
    try {
      const data = {
        apiUrl: apiService.futureTradeHistory,
      };
      setSiteLoader(true);
      const resp = await getMethod(data);
      setSiteLoader(false);

      if (resp.status) {
        setTradeHistory(resp.data);
      } else {
        setTradeHistory([]);
      }
    } catch (error) {
      setTradeHistory([]);
    }
  };


  const cancelOrder = async (orderId, symbol) => {
    try {
      setSiteLoader(true);

      const data = {
        apiUrl: apiService.futureCancelOrder,
        payload: { orderId, symbol },
      };

      const resp = await postMethod(data);

      if (resp.status) {
        toast.success("Order cancelled successfully");
        History();
      } else {
        toast.error(resp.message || "Failed to cancel order");
      }
    } catch (error) {
      toast.error("Something went wrong while cancelling the order");
    }

    finally {
      setSiteLoader(false);

    }
  };



  const placeOrder = async (side) => {
    const type = activeLimitsref.current;
    const inputs = inputsref.current;

    const validationError = validateOrder();
    if (validationError) {
      toast.error(validationError);
      return;
    }

    let orderPayload = {
      symbol: currentPair,
      side: side.toUpperCase(),
      type: type === "stoplimit" ? "STOP_MARKET" : type.toUpperCase(),
      reduceOnly: isCheckedReduce,
      positionSide: "BOTH",
    };

    const getNotional = async (price, qty) => {
      return price * qty;
    };

    const getMarketPrice = async () => {
      try {
        const res = await axios.get(`https://fapi.binance.com/fapi/v1/ticker/price?symbol=${currentPair}`);
        return parseFloat(res.data.price);
      } catch (err) {
        return null;
      }
    };

    const validateQtyAndNotional = async (qty, price) => {
      if (qty < min) {
        toast.error(`Quantity is below minimum (${min})`);
        return false;
      }
      if (qty > Max) {
        toast.error(`Quantity exceeds maximum (${Max})`);
        return false;
      }
      const notional = await getNotional(price, qty);
      if (notional < 5 && !orderPayload.reduceOnly) {
        toast.error("Order value must be at least 5 USDT.");
        return false;
      }
      return true;
    };

    // ✅ MARKET ORDER
    if (type === "market") {
      const qty = parseFloat(inputs.size);
      const price = await getMarketPrice();
      if (!price || !(await validateQtyAndNotional(qty, price))) return;

      orderPayload.quantity = qty;
    }

    // ✅ LIMIT ORDER
    if (type === "limit") {
      const qty = parseFloat(inputs.limitsize);
      const price = parseFloat(inputs.limitprice);
      if (!(await validateQtyAndNotional(qty, price))) return;

      orderPayload.quantity = qty;
      orderPayload.price = price;
      orderPayload.timeInForce = "GTC";
    }

    // ✅ STOP-LIMIT / STOP-MARKET
    if (type === "stoplimit") {
      const qty = parseFloat(inputs.stopsize);
      const price = parseFloat(inputs.stopprice);
      if (!(await validateQtyAndNotional(qty, price))) return;

      orderPayload.stopPrice = price;
      orderPayload.quantity = qty;
      orderPayload.timeInForce = "GTC";
    }

    // ✅ Optional TP/SL
    if (isChecked) {
      if (inputs.takeProfit) orderPayload.activationPrice = inputs.takeProfit;
      if (inputs.stopLoss) orderPayload.stopLoss = inputs.stopLoss;
    }

    setSiteLoader(true);

    try {
      const data = {
        apiUrl: apiService.placeFutureOrder,
        payload: orderPayload,
      };

      const response = await postMethod(data);

      if (response.status === true) {
        getUserbalance(currentPair);
        toast.success("Order placed successfully");
      } else {
        toast.error(response.message || "Order failed");
      }
    } catch (err) {

    } finally {
      setSiteLoader(false);
      History();

      setInputs({
        size: "",
        limitsize: "",
        stopsize: "",
        limitprice: "",
        stopprice: "",
        stoplimitprice: "",
        takeProfit: "",
        stopLoss: "",
      });

      setInputs((prev) => ({
        ...prev,
        limitprice: markPrice,
        stoplimitprice: markPrice,
      }));
    }
  };


  return (
    <div>
      <Header />
      {siteLoaderref.current == true ? (
        <div className="loadercss">
          <Bars
            height="80"
            width="80"
            color="#ffc630"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      ) : (

        <div>
          <div className="header">
            <main className="min-height-100vh">
              <div className="container">
                <div className="future_hero_trade">
                  <div className="future_first_main">
                    {CurrencyList.map((ticker, index) => {
                      const change = parseFloat(
                        ticker.priceChangePercent
                      ).toFixed(2);
                      const isNegative = parseFloat(change) < 0;
                      return (
                        <div
                          className="future_first_main_inner"
                          key={index}
                          onClick={() => pairChange(ticker.symbol)}
                        >
                          <span className="first_main_innerfuspa">
                            <img
                              src={ticker.Currency_image}
                              alt={ticker.symbol}
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "5px",
                              }}
                            />
                            {ticker.symbol}
                          </span>
                          <span
                            className={isNegative ? "colorRed" : "colorGreen"}
                          >
                            {isNegative ? "" : "+"}
                            {change}%
                          </span>
                        </div>
                      );
                    })}
                  </div>
                  <div className="future_scnd_main">
                    <div className="future_scnd_lft">
                      <div className="future_scnd_lft_side">

                        <span className="future_scnd_lft_head">
                          {tickerPrice?.symbol}
                        </span>
                        <div className="future_top_prep">
                          <span>Perp</span>
                        </div>
                      </div>
                      <div class="btn-group p-0">
                        <button
                          class="btn btn-secondary btn-lg dropdown-toggle more-select"
                          type="button"
                          data-bs-toggle="dropdown"
                        // aria-expanded="false"
                        ></button>

                        <ul class="dropdown-menu op-sbh-dropdown">
                          <div className="more-links">
                            <Link className="nav-trade-links ">
                              <div className="">
                                {CurrencyList.map((ticker, index) => {
                                  const change = parseFloat(
                                    ticker.priceChangePercent
                                  ).toFixed(2);
                                  const isNegative = parseFloat(change) < 0;
                                  return (
                                    <Link
                                      className="nav-trade-links"
                                      to={`/futuretrade/${ticker.symbol}`}
                                      onClick={
                                        () => {
                                          getLiveMarket(ticker.symbol);
                                        }
                                      }
                                      key={index}
                                    >
                                      <div className="d-flex justify-content-between mb-4">
                                        <span className="first_main_innerfuspa">
                                          <img
                                            src={ticker.Currency_image}
                                            alt={ticker.symbol}
                                            style={{
                                              width: "24px",
                                              height: "24px",
                                              marginRight: "5px",
                                            }}
                                          />
                                          {ticker.symbol}
                                        </span>
                                        <span>{ticker.curDayClose}</span>
                                        <span className={isNegative ? "colorRed" : "colorGreen"}>
                                          {isNegative ? "" : "+"}
                                          {change}%
                                        </span>
                                      </div>
                                    </Link>

                                  );
                                })}

                              </div>
                            </Link>
                          </div>
                        </ul>
                      </div>
                      <div className="future_scnd_lft_pric">
                        <span
                          className={`future_par_manpri ${isNegative ? "" : "colorGreen"
                            }`}
                        >
                          {" "}
                          {tickerPrice?.curDayClose}{" "}
                        </span>
                        <span
                          className={`future_par_subpri ${isNegative ? "" : "colorGreen"
                            }`}
                        >
                          {tickerPrice?.priceChangePercent}%
                        </span>
                      </div>
                    </div>
                    <div className="future_scnd_right">
                      <div className="future_scnd_right_inner">
                        <span className="future_scnd_in_had">24hr Change</span>
                        <span className="future_scnd_in_subhed">
                          {tickerPrice?.priceChange}{" "}
                        </span>
                      </div>
                      {/* <div className="future_scnd_right_inner">
                      <span className="future_scnd_in_had">Index</span>
                      <span className="future_scnd_in_subhed">65,777.00</span>
                    </div>
                    <div className="future_scnd_right_inner">
                      <span className="future_scnd_in_had">
                        Funding / Countdown
                      </span>
                      <span className="future_scnd_in_subhed">
                        65,777.00 / 02:21:41
                      </span>
                    </div> */}
                      <div className="future_scnd_right_inner">
                        <span className="future_scnd_in_had"> 24 High</span>
                        <span className="future_scnd_in_subhed">
                          {tickerPrice?.high}
                        </span>
                      </div>
                      <div className="future_scnd_right_inner">
                        <span className="future_scnd_in_had">24h Low</span>
                        <span className="future_scnd_in_subhed">
                          {" "}
                          {tickerPrice?.low}{" "}
                        </span>
                      </div>
                      <div className="future_scnd_right_inner">
                        <span className="future_scnd_in_had">
                          24h Volume(BTC)
                        </span>
                        <span className="future_scnd_in_subhed">
                          {tickerPrice?.volume}
                        </span>
                      </div>
                      <div className="future_scnd_right_inner">
                        <span className="future_scnd_in_had">
                          24h Volume(USDT)
                        </span>
                        <span className="future_scnd_in_subhed">
                          {tickerPrice?.volumeQuote}
                        </span>
                      </div>
                      <div className="future_scnd_right_inner">
                        <span className="future_scnd_in_had">
                          {" "}
                          Open Interest(USDT)
                        </span>
                        <span className="future_scnd_in_subhed">
                          1,839,020,199.75
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-3 no-pad-new">
                      <div className="future_order_book">
                        <div className="contant_scetion">

                          <div className="market_order h-300-future">
                            <article>
                              <section class="orderbook-header ml-0 mr-0">
                                <table width="100%">
                                  <tr>
                                    <th class="price" width="25%">
                                      Price(USDT)
                                    </th>
                                    <th width="25%">Amount(BTC)</th>
                                    <th width="25%">Total</th>
                                  </tr>
                                </table>
                              </section>

                              <section className="side" id="asks">
                                <table width="100%" className="green_content">
                                  <tbody>
                                    {orderBook.asks.map((ask, i) => {
                                      const total = (
                                        parseFloat(ask.price) *
                                        parseFloat(ask.quantity)
                                      ).toFixed(2);
                                      return (
                                        <tr key={i}>
                                          <td
                                            width="25%"
                                            className="price sell priceclick py-1"
                                          >
                                            {ask.price}
                                          </td>
                                          <td width="25%" className="py-1">
                                            {ask.quantity}
                                          </td>
                                          <td width="25%" className="py-1">
                                            {total}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </section>

                              <div className={` my-3 future_par_manpri ${tickerPrice?.priceChangePercent >= 0
                                ? " text-green"
                                : " text-red"
                                }`}>
                                {tickerPrice?.curDayClose || "00.00"}
                                <span>
                                  <i
                                    className={`fa-solid mx-3 ${tickerPrice?.priceChangePercent >= 0
                                      ? "fa-arrow-up colorGreen"
                                      : "fa-arrow-down colorRed"
                                      }`}
                                  ></i>
                                </span>
                                <span className="current-down-price">
                                  {tickerPrice?.priceChangePercent ?? 0} %
                                </span>
                              </div>

                              <section className="side bids">
                                <table width="100%">
                                  <tbody>
                                    {orderBook.bids.map((bid, i) => {
                                      const total = (
                                        parseFloat(bid.price) *
                                        parseFloat(bid.quantity)
                                      ).toFixed(2);
                                      return (
                                        <tr key={i}>
                                          <td
                                            width="25%"
                                            className="red-green price buy priceclick py-1"
                                          >
                                            {bid.price}
                                          </td>
                                          <td width="25%" className="py-1">
                                            {bid.quantity}
                                          </td>
                                          <td width="25%" className="py-1">
                                            {total}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </section>
                            </article>
                          </div>
                          {/* <div className="future_trades pb-0">
                            <div className="">
                              <div className="form_seldect__pair pt-0">
                                <ul class="nav nav-pills mt-3">
                                  <li class="active">
                                    <a
                                      className={`${activeTab === "mytrade" ? "active" : ""
                                        }`}
                                      onClick={() => setActiveTab("mytrade")}
                                    >
                                      Market Trades
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className={`${activeTab === "trade" ? "active" : ""
                                        }`}
                                      onClick={() => setActiveTab("trade")}
                                    >
                                      My Trades
                                    </a>
                                  </li>
                                </ul>

                                <div class="tab-content pair_details">
                                  <div
                                    id="mtrade"
                                    class={`tab-pane fade in ${activeTab === "mytrade" ? "show active" : ""
                                      } show bor_1 mar-top`}
                                  >
                                    <div class="fixTableHead mt-2">
                                      <table>
                                        <thead>
                                          <tr>
                                            <th className="market-trades">
                                              Price (USDT)
                                            </th>
                                            <th className="text-end market-trades">
                                              Amount (BTC)
                                            </th>
                                            <th className="text-end market-trades">
                                              Time
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr className="position_rel_over">
                                            <td className="market-price-td">
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">1234</td>
                                            <td className="text-end">11.11.11</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td className="market-price-td">
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">1234</td>
                                            <td className="text-end">11.11.11</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td className="market-price-td">
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">1234</td>
                                            <td className="text-end">11.11.11</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td className="market-price-td">
                                              <span className="reds">00.00</span>
                                            </td>
                                            <td className="text-end">1234</td>
                                            <td className="text-end">11.11.11</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td className="market-price-td">
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">1234</td>
                                            <td className="text-end">11.11.11</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>

                                  <div
                                    id="mytrade"
                                    class={`tab-pane ${activeTab === "trade" ? "show active" : ""
                                      } show bor_1 mar-top fade`}
                                  >
                                    <div class="fixTableHead mt-2">
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Pair (USDT)</th>
                                            <th className="text-end">
                                              Price (BTC)
                                            </th>
                                            <th className="text-end">Time</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr className="position_rel_over">
                                            <td>
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">4321</td>
                                            <td className="text-end">22.22.22</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td>
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">4321</td>
                                            <td className="text-end">22.22.22</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td>
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">4321</td>
                                            <td className="text-end">22.22.22</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td>
                                              <span className="reds">00.00</span>
                                            </td>
                                            <td className="text-end">4321</td>
                                            <td className="text-end">22.22.22</td>
                                          </tr>
                                          <tr className="position_rel_over">
                                            <td>
                                              <span className="color-buy">
                                                00.00
                                              </span>
                                            </td>
                                            <td className="text-end">4321</td>
                                            <td className="text-end">22.22.22</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 forex_trade-center p-0">
                      <TradingViewWidget symbol={currentPair} />
                    </div>

                    {/* <div className="col-lg-3 no_pad_rghnew">
                    <div className="future_righ_man">
                      <div className="future_righ_strt">
                        <div className="future_righ_strt_main">
                          <div className="future_righ_strt_top">
                            <div className="futr_tp_inbox">
                              <span>Cross</span>
                            </div>
                            <div className="futr_tp_inbox">
                              <span>5x</span>
                            </div>

                          </div>
                          <div className="future_righ_strt_iner">
                            <div className="future_limi_mar">
                              <span
                                className={
                                  activeLimitsref.current == "limit"
                                    ? "future_limit_active"
                                    : "future_limit_innactive"
                                }
                                onClick={() => handleLimit("limit")}
                              >
                                Limit
                              </span>
                              <span
                                className={
                                  activeLimitsref.current == "market"
                                    ? "future_limit_active"
                                    : "future_limit_innactive"
                                }
                                onClick={() => handleLimit("market")}
                              >
                                Market
                              </span>
                              <span
                                className={
                                  activeLimitsref.current == "stoplimit"
                                    ? "future_limit_active"
                                    : "future_limit_innactive"
                                }
                                onClick={() => handleLimit("stoplimit")}
                              >
                                Stop-limit
                              </span>
                            </div>
                            <div className="future_limi_below">
                              <span className="future_limi_bel_avai">
                                <span>Avbl</span> - 0.000000USDT
                              </span>
                              <div className="future_rght_frstinp">
                                <div className="future_rght_frstinp_lef">
                                  <input
                                    type="number"
                                    className="future_rght_frstinp_inner"
                                    placeholder="Price"
                                  />
                                  <span className="futu_frsinnp_span">
                                    <span>Last</span> USDT
                                  </span>
                                </div>
                                <div className="futu_ininp_rig">
                                  <span>BBO</span>
                                </div>
                              </div>
                              <div className="future_rght_scndinp">
                                <input
                                  type="number"
                                  className="future_rght_frstinp_inner"
                                  placeholder="Amount"
                                />
                                <div className="futre_chng_frst">
                                  <Dropdown
                                    inline
                                    placeholder="BTC"
                                    options={options}
                                  />
                                </div>
                              </div>
                              <ThemeProvider theme={themeSlider}>
                                <div className="slider_spacing">
                                  <Box>
                                    <Slider
                                      value={3}
                                      step={1}
                                      marks
                                      name="buy"
                                      min={0}
                                      max={100}
                                      // onChange={handleSliderChange2}
                                      sx={{
                                        "& .MuiSlider-track": {
                                          backgroundColor: "#1E2026",
                                        },
                                        "& .MuiSlider-thumb": {
                                          backgroundColor: "#1E2026",
                                        },
                                      }}
                                    />
                                  </Box>
                                </div>
                              </ThemeProvider>

                              <div className="fut_tp_buysell">
                                <span className="fut_buy_spa">
                                  <span>Buy</span> 0.000 0 BTC
                                </span>
                                <span className="fut_buy_spa">
                                  <span>Sell</span> 0.000 0 BTC
                                </span>
                              </div>

                              <div className="future_set_inn_inner_centch">
                                <div class="checkbox-container-futureset">
                                  <input
                                    id="custom-checkbox"
                                    checked={isChecked}
                                    onChange={handleTerms}
                                    className="input-field regular_checkbox"
                                    type="checkbox"
                                    placeholder="Enter the referral ID (optional)"
                                  />
                                  <label htmlFor="custom-checkbox"></label>
                                </div>
                                <label
                                  htmlFor="custom-checkbox"
                                  className="terms-check-futureset"
                                >
                                  TP/SL
                                </label>
                              </div>

                              <div className="futur_in_midche">
                                <div className="future_set_inn_inner_centch">
                                  <div class="checkbox-container-futureset">
                                    <input
                                      id="custom-checkbox-reduce"
                                      checked={isCheckedReduce}
                                      onChange={handleTermsReduce}
                                      className="input-field regular_checkbox"
                                      type="checkbox"
                                    />
                                    <label htmlFor="custom-checkbox-reduce"></label>
                                  </div>
                                  <label
                                    htmlFor="custom-checkbox-reduce"
                                    className="terms-check-futureset"
                                  >
                                    Reduce-Only
                                  </label>
                                </div>
                                <div className="futur_in_midche_rght">
                                  <span>TIF</span>
                                  <div className="futre_chng_secc">
                                    <Dropdown
                                      inline
                                      placeholder="GTC"
                                      options={options}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="futur_btn_imp">
                                <div className="futur_btn_imp_singl">
                                  <div className="futur_btn_imp_btn">
                                    <span>Buy/Long</span>
                                  </div>
                                  <div className="futur_btn_imp_lowe">
                                    <span className="futur_btn_Lowe_span">
                                      <span>Liq Price</span> -- BTC
                                    </span>
                                    <span className="futur_btn_Lowe_span">
                                      <span>Cost</span> 0.000 USDT
                                    </span>
                                    <span className="futur_btn_Lowe_span">
                                      <span>Max</span> 0.000 BTC
                                    </span>
                                  </div>
                                </div>
                                <div className="futur_btn_imp_singl">
                                  <div className="futur_btn_imp_btn_red">
                                    <span>Sell/Short</span>
                                  </div>
                                  <div className="futur_btn_imp_lowe_rig">
                                    <span className="futur_btn_Lowe_span_rig">
                                      <span>Liq Price</span> -- BTC
                                    </span>
                                    <span className="futur_btn_Lowe_span_rig">
                                      <span>Cost</span> 0.000 USDT
                                    </span>
                                    <span className="futur_btn_Lowe_span_rig">
                                      <span>Max</span> 0.000 BTC
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span className="future_rg_per">
                          <span>%</span> Free level
                        </span>
                      </div>
                      <div className="futur_acc_min">
                        <span>Account</span>
                        <i class="fa-solid fa-arrow-right-arrow-left"></i>
                      </div>
                      <div className="acc_inf_fut">
                        <div className="acc_inf_fut_inn">
                          <div className="acc_futin_inn">
                            <span>Account Margin Ratio</span>
                            <span>0.00%</span>
                          </div>
                          <div className="acc_futin_inn">
                            <span>Account Maintenance Margin</span>
                            <span>0.00 USD</span>
                          </div>
                          <div className="acc_futin_inn">
                            <span> Account Equity</span>
                            <span>0.00 USD</span>
                          </div>
                          <div className="acc_futin_inn">
                            <span> Position Value</span>
                            <span>0.00 USD</span>
                          </div>
                          <div className="acc_futin_inn">
                            <span>Actual Leverage</span>
                            <span>0.00 USD</span>
                          </div>
                        </div>
                        <div className="acc_befut_btn">
                          <span>Multi-Assets</span>
                        </div>
                      </div>
                      <div className="fut_bot_not">
                        <div className="futre_chng_thirr">
                          <Dropdown
                            inline
                            placeholder="USDT"
                            options={options}
                          />
                        </div>
                        <div className="fut_loe_note">
                          <i class="fa-solid fa-circle-info"></i>
                          <span>
                            {" "}
                            Please transfer assets into your futures account to
                            start trading
                          </span>
                        </div>
                        <div className="fut_note_smlbt">
                          <div className="fut_note_smlbt_box">
                            <span>Buy Crypto</span>
                          </div>
                          <div className="fut_note_smlbt_box">
                            <span>Swap</span>
                          </div>
                          <div className="fut_note_smlbt_box">
                            <span>Transfer</span>
                          </div>
                        </div>
                      </div>
                      <div className="fut_last_man">
                        <span className="fut_last_man_head">
                          Supercharge return with BFUSD
                        </span>
                        <div className="ftu_lat_botto">
                          <span>BFUSD Balance</span>
                          <span> 0.00 BFUSD</span>
                        </div>
                        <div className="ftu_lat_botto">
                          <span>Reward</span>
                          <span> 0.00 USDT</span>
                        </div>
                      </div>
                    </div>
                  </div> */}

                    <div className="col-lg-3 no_pad_rghnew">
                      <div className="future_righ_man">
                        <div className="future_righ_strt">
                          <div className="future_righ_strt_main">
                            <div className="future_righ_strt_top">
                              <div
                                className="futr_tp_inbox"
                                onClick={() => handleOpen()}
                              >
                                <span>{marginMode}</span>
                              </div>
                              <div
                                className="futr_tp_inbox"
                                onClick={() => handleleverOpen()}
                              >
                                <span> {leverage} x</span>
                              </div>
                            </div>

                            <div className="future_righ_strt_iner">
                              <div className="future_limi_mar">
                                {["limit", "market", "stoplimit"].map((type) => (
                                  <span
                                    key={type}
                                    className={
                                      activeLimitsref.current === type
                                        ? "future_limit_active"
                                        : "future_limit_innactive"
                                    }
                                    onClick={() => handleLimit(type)}
                                  >
                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                  </span>
                                ))}
                              </div>

                              <div className="future_limi_below">
                                <span className="future_limi_bel_avai">
                                  <span>Avbl</span> : {tobalanceref.current} USDT
                                </span>


                                {renderInputs()}

                                <>
                                  <ThemeProvider theme={themeSlider}>
                                    <div className="slider_spacing">
                                      <Box>
                                        <Slider
                                          value={sliderValue}
                                          step={25}
                                          marks
                                          min={0}
                                          max={100}
                                          onChange={handleSliderChange}
                                          sx={{
                                            "& .MuiSlider-track": {
                                              backgroundColor: "#00000",
                                              border: "1px solid #ffc630",
                                            },
                                            "& .MuiSlider-rail": {
                                              backgroundColor: "#00000",
                                              border: "1px solid #ffc630",
                                            },
                                            "& .MuiSlider-thumb": {
                                              backgroundColor: "#1E2026",
                                            },
                                          }}
                                        />

                                      </Box>
                                    </div>
                                  </ThemeProvider>
                                  <div className="trad_new_perc">
                                    <span>0%</span>
                                    <span>25%</span>
                                    <span>50%</span>
                                    <span>75%</span>
                                    <span>100%</span>
                                  </div>
                                </>

                                <div className="fut_tp_buysell">
                                  <span
                                    className="fut_buy_spa"
                                    onClick={() => placeOrder("BUY")}
                                  >
                                    <span>Min</span> {min} USDT
                                  </span>
                                  <span
                                    className="fut_buy_spa"
                                    onClick={() => placeOrder("SELL")}
                                  >
                                    <span>Max</span> {Max} USDT
                                  </span>
                                </div>

                                <div className="future_set_inn_inner_centch">
                                  <div className="checkbox-container-futureset">
                                    <input
                                      id="custom-checkbox"
                                      checked={isChecked}
                                      onChange={handleTerms}
                                      disabled={isCheckedReduce}
                                      className="input-field regular_checkbox"
                                      type="checkbox"
                                    />
                                    <label htmlFor="custom-checkbox"></label>
                                  </div>
                                  <label
                                    htmlFor="custom-checkbox"
                                    className="terms-check-futureset"
                                  >
                                    TP/SL
                                  </label>
                                </div>

                                {isChecked && (
                                  <>
                                    <div className="future_rght_frstinp_lef">
                                      <input
                                        type="number"
                                        name="takeProfit"
                                        value={inputsref.current.takeProfit}
                                        min={0}
                                        onChange={handleInputChange}
                                        className="future_rght_frstinp_inner"
                                        placeholder="Take Profit"
                                      />
                                    </div>

                                    <div className="future_rght_frstinp_lef">
                                      <input
                                        type="number"
                                        name="stopLoss"
                                        value={inputsref.current.stopLoss}
                                        min={0}
                                        onChange={handleInputChange}
                                        className="future_rght_frstinp_inner"
                                        placeholder="Stop Loss"
                                      />
                                    </div>
                                  </>
                                )}
                                <div className="futur_in_midche">
                                  <div className="future_set_inn_inner_centch">
                                    <div className="checkbox-container-futureset">
                                      <input
                                        id="custom-checkbox-reduce"
                                        checked={isCheckedReduce}
                                        onChange={handleTermsReduce}
                                        className="input-field regular_checkbox"
                                        type="checkbox"
                                      />
                                      <label htmlFor="custom-checkbox-reduce"></label>
                                    </div>
                                    <label
                                      htmlFor="custom-checkbox-reduce"
                                      className="terms-check-futureset"
                                    >
                                      Reduce-Only
                                    </label>
                                  </div>
                                </div>

                                {/* Buy/Sell Summary */}


                                {loginStatus ? (
                                  <div className="futur_btn_imp">
                                    {["Buy/Long", "Sell/Short"].map((action, i) => {
                                      const isBuy = i === 0;
                                      const metrics = isBuy ? tradeMetrics?.buy : tradeMetrics?.sell;
                                      const data = action == "Buy/Long" ? "BUY" : "SELL";


                                      return (
                                        <div className="futur_btn_imp_singl" key={action}>
                                          <button
                                            className={isBuy ? "futur_btn_imp_btn" : "futur_btn_imp_btn_red"}
                                            onClick={() => placeOrder(data)}
                                            disabled={siteLoader}
                                          >
                                            <span>{action}</span>
                                          </button>
                                        </div>
                                      );
                                    })}
                                  </div>
                                ) : (
                                  <Button className="buy_selecu_beforelog" onClick={() => loginNave()}>
                                    Login to continue
                                  </Button>
                                )}



                                <div className="futur_btn_imp">

                                  <div className="futur_btn_imp_singl">


                                    <div className={"futur_btn_imp_lowe"}>
                                      <span className={"futur_btn_Lowe_span"}>
                                        Liq Price = {tradeMetrics?.buy?.liqPrice || "--"} USDT
                                      </span>
                                      <span className={"futur_btn_Lowe_span"}>
                                        Cost = {tradeMetrics?.buy?.cost || "--"} USDT
                                      </span>
                                      <span className={"futur_btn_Lowe_span"}>
                                        Max = {tradeMetrics?.buy?.max || "--"}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="futur_btn_imp_singl">

                                    <div className={"futur_btn_imp_lowe_rig"}>
                                      <span className={"futur_btn_Lowe_span"}>
                                        Liq Price = {tradeMetrics?.sell?.liqPrice || "--"} USDT
                                      </span>
                                      <span className={"futur_btn_Lowe_span"}>
                                        Cost = {tradeMetrics?.sell?.cost || "--"} USDT
                                      </span>
                                      <span className={"futur_btn_Lowe_span"}>
                                        Max = {tradeMetrics?.sell?.max || "--"}
                                      </span>
                                    </div>
                                  </div>


                                </div>


                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="easy_Low_main">
                  <div className="easy_Low_main_top">
                    <span
                      className={`easy_low_tabhead ${activeTabheadref.current === "orders" ? "active" : ""}`}
                      onClick={() => handleTabs("orders")}
                    >
                      Open Orders ({openOrrdersref.current.length})
                    </span>
                    <span
                      className={`easy_low_tabhead ${activeTabheadref.current === "history" ? "active" : ""}`}
                      onClick={() => handleTabs("history")}
                    >
                      Order History
                    </span>
                    <span
                      className={`easy_low_tabhead ${activeTabheadref.current === "trades" ? "active" : ""}`}
                      onClick={() => handleTabs("trades")}
                    >
                      Trade History
                    </span>
                  </div>

                  <div className="w-100 mb-5">
                    <div className="table-responsive table-cont otc_spot_tableup">
                      <table className="table">
                        <thead>
                          <tr className="stake-head font-satoshi">
                            <th>Symbol</th>
                            <th className="txt-center">Size</th>
                            <th className="txt-center">Type</th>
                            <th className="txt-center">Side</th>
                            <th className="txt-center">Status</th>
                            <th className="txt-center">Time</th>
                            {activeTabheadref.current === "orders" && (
                              <th className="txt-center">Action</th>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {activeTabheadref.current === "orders" && openOrrdersref.current.length > 0 ? (
                            openOrrdersref.current.map((item, idx) => (
                              <tr key={idx}>
                                <td>{item.symbol}</td>
                                <td className="txt-center">{item.quantity}</td>
                                <td className="txt-center">{item.type}</td>
                                <td className="txt-center">{item.side}</td>
                                <td className="txt-center">{item.status}</td>
                                <td className="txt-center">{new Date(item.createdAt).toLocaleString()}</td>
                                <td className="txt-center">
                                  <button className="btn btn-danger btn-sm"

                                    onClick={() => {
                                      cancelOrder(item.orderId, item.symbol);
                                    }}

                                  >Cancel</button>
                                </td>
                              </tr>
                            ))
                          ) : activeTabheadref.current === "history" && orderhistoryref.current.length > 0 ? (
                            orderhistoryref.current.map((item, idx) => (
                              <tr key={idx}>
                                <td>{item.symbol}</td>
                                <td className="txt-center">{item.quantity}</td>
                                <td className="txt-center">{item.type}</td>
                                <td className="txt-center">{item.side}</td>
                                <td className="txt-center">{item.status}</td>
                                <td className="txt-center">{new Date(item.createdAt).toLocaleString()}</td>
                              </tr>
                            ))
                          ) : activeTabheadref.current === "trades" && tradeHistoryref.current.length > 0 ? (
                            tradeHistoryref.current.map((item, idx) => (
                              <tr key={idx}>
                                <td>{item.symbol}</td>
                                <td className="txt-center">{item.quantity}</td>
                                <td className="txt-center">{item.type}</td>
                                <td className="txt-center">{item.side}</td>
                                <td className="txt-center">{item.status}</td>
                                <td className="txt-center">{new Date(item.createdAt).toLocaleString()}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={activeTabheadref.current === "orders" ? 7 : 6} className="text-center py-5">


                                {loginStatus ? (
                                  <div className="empty_data">
                                    <div className="empty_data_img py-4">
                                      <img
                                        src={require("../assets/no-copytrade-data.webp")}
                                        width="100px"
                                        alt="No data"
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <Button className="buy_selecu_beforelog" onClick={() => loginNave()}>
                                    Login to continue
                                  </Button>
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>


                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="email-popup-modal-title"
                  aria-describedby="email-popup-modal-description"
                >
                  <Box sx={style}>
                    <div className="">
                      <div className="modal-content">
                        <div className="modal-header lvl-one-header pb-3">
                          <h1 className="modal-title fs-5" id="exampleModalLabel">
                            <span className="mar-lft-2">Margin Mode </span>
                          </h1>
                          <button
                            type="button"
                            className="btn-close btn-close-custom"
                            onClick={handleClose}
                          ></button>
                        </div>

                        <div className="future_scnd_lft_side p-4">
                          <span className="future_scnd_lft_head">
                            {tickerPrice?.symbol}
                          </span>
                          <div className="future_top_prep">
                            <span>Perp</span>
                          </div>
                        </div>

                        <div className="modal-not-header">
                          <div className="modal-notify-content">
                            Switching the margin mode will only apply it to the
                            selected contract.
                          </div>

                          <div className="d-flex justify-content-between mt-4">
                            <Button
                              className={`future-btn ${marginMode == "Isolated" ? "active" : ""
                                }`}
                              onClick={() => {
                                setMarginMode("Isolated");
                                handleClose();
                              }}
                            >
                              Isolated
                            </Button>

                            <Button
                              className={`future-btn ${marginMode == "Cross" ? "active" : ""
                                }`}
                              onClick={() => {
                                setMarginMode("Cross");
                                handleClose();
                              }}
                            >
                              Cross
                            </Button>
                          </div>
                        </div>

                        <div className="modal-body personal_verify_body  px-4 my-3">
                          <div className="mar-top-9">
                            <div className="first_name">
                              <h4 className="select_id_text">
                                Cross Margin Mode: All cross positions under the
                                same margin asset share the same asset cross
                                margin balance. In the event of liquidation, your
                                assets full margin balance along with any
                                remaining open positions under the asset may be
                                forfeited
                              </h4>

                              <h4 className="select_id_text">
                                Isolated Margin Mode: Manage your risk on
                                individual positions by restricting the amount of
                                margin allocated to each. If the margin ratio of a
                                position reached 100%, the position will be
                                liquidated. Margin can be added or removed to
                                positions using this mode.
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={leverOpen}
                  onClose={handleClose}
                  aria-labelledby="adjust-leverage-title"
                  aria-describedby="adjust-leverage-description"
                >
                  <Box sx={style}>
                    <div className="modal-content">
                      <div className="modal-header lvl-one-header pb-3">
                        <h1
                          className="modal-title fs-5"
                          id="adjust-leverage-title"
                        >
                          Adjust Leverage
                        </h1>
                        <button
                          type="button"
                          className="btn-close btn-close-custom"
                          onClick={handleClose}
                        ></button>
                      </div>

                      <div className="modal-body personal_verify_body lvl-one-body">
                        <div className="">
                          <div className="d-flex align-items-center justify-content-between mb-4">
                            <button
                              className="px-3 py-1 border rounded"
                              onClick={() => {
                                handleSliderChange("", 0);
                                setLeverage((prev) => Math.max(1, prev - 1));
                              }
                              }
                            >
                              −
                            </button>
                            <span className="modal-title">{leverage}x</span>
                            <button
                              className="px-3 py-1 border rounded"
                              onClick={() => {
                                setLeverage((prev) => Math.min(125, prev + 1));
                                handleSliderChange("", 0);
                              }
                              }
                            >
                              +
                            </button>
                          </div>
                          <ThemeProvider theme={themeSlider}>
                            <div className="slider_spacing">
                              <Box>
                                <Slider
                                  value={leverage}
                                  step={1}
                                  onChange={(e) => {
                                    setLeverage(Number(e.target.value));
                                    handleSliderChange("", 0);
                                  }
                                  }
                                  marks
                                  min={1}
                                  max={125}
                                  name="buy"
                                  sx={{
                                    "& .MuiSlider-track": {
                                      backgroundColor: "#1E2026",
                                    },
                                    "& .MuiSlider-thumb": {
                                      backgroundColor: "#1E2026",
                                    },
                                  }}
                                />
                              </Box>
                            </div>
                          </ThemeProvider>

                          <div className="select_id_text mt-3">
                            * Maximum position at current leverage: 40,000,000
                            USDT
                          </div>
                          <div className="select_id_text mt-3 width-100">
                            Changing leverage will apply to open positions and
                            open orders.
                          </div>

                          <div className="mt-3 select_id_text">
                            * Selecting higher leverage such as [{leverage}x]
                            increases your liquidation risk. Always manage your
                            risk levels. See our{" "}
                            <a href="#" className="underline">
                              help article
                            </a>{" "}
                            for more info.
                          </div>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Modal>
              </div>
            </main>
          </div>
        </div>

      )}

    </div>
  );
}

export default FutureTrade;
